<div class="p-6">
    <h1 class="text-2xl font-semibold text-gray-900 mb-8">User Management</h1>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl">
        <a routerLink="/user-management/operator-management"
            class="flex items-center gap-4 p-6 rounded-xl border border-gray-200 bg-white hover:bg-blue-50 hover:border-blue-300 transition-colors cursor-pointer no-underline">
            <mat-icon class="text-blue-600"
                style="font-size:40px;height:40px;width:40px;">admin_panel_settings</mat-icon>
            <div>
                <h2 class="text-lg font-semibold text-gray-900 m-0">Operators</h2>
                <p class="text-sm text-gray-500 m-0">Manage parking operators</p>
            </div>
        </a>

        <a routerLink="/user-management/groups"
            class="flex items-center gap-4 p-6 rounded-xl border border-gray-200 bg-white hover:bg-blue-50 hover:border-blue-300 transition-colors cursor-pointer no-underline">
            <mat-icon class="text-blue-600" style="font-size:40px;height:40px;width:40px;">group_work</mat-icon>
            <div>
                <h2 class="text-lg font-semibold text-gray-900 m-0">Groups</h2>
                <p class="text-sm text-gray-500 m-0">Manage operator groups</p>
            </div>
        </a>
    </div>
</div>